<app-resp-popup-title>
  <span>{{ bezeichnung }}</span>
</app-resp-popup-title>
<app-resp-popup-content>
  @if (form) {
    <div class="container">
      <form [formGroup]="form">
        <frm-text
          i18n-label="@@PlanungAPI_FormularCreate_Description"
          label="Description"
          [multiline]="true"
          formControlName="beschreibung"
          rows="6"
        ></frm-text>
      </form>
      @if (pdfs?.length > 0) {
        <div class="preview">
          <div style="display: flex; justify-content: space-between">
            @if (pdfs.length > 1) {
              <ctrl-btn
                icon="navigate_before"
                [flat]="true"
                (click)="onPreviewBefore()"
              ></ctrl-btn>
            } @else {
              <div></div>
            }
            <ctrl-btn
              icon="open_in_new"
              [iconPositionRight]="true"
              class="preview-title"
              [flat]="true"
              [content]="pdfs[currentPdfIdx].label"
              (click)="onPreviewPopup()"
            ></ctrl-btn>
            @if (pdfs.length > 1) {
              <ctrl-btn
                icon="navigate_next"
                [flat]="true"
                (click)="onPreviewNext()"
              ></ctrl-btn>
            } @else {
              <div></div>
            }
          </div>
          <cst-pdf-viewer [src]="pdfs[currentPdfIdx].data" [textSelectable]="false">
          </cst-pdf-viewer>
        </div>
      }
    </div>
  }
</app-resp-popup-content>
<app-resp-popup-actions>
  <ctrl-btn-accept
    [disabled]="!form.valid"
    (click)="onAccept()"
  ></ctrl-btn-accept>
  <ctrl-btn-cancel (click)="onCancel()"></ctrl-btn-cancel>
</app-resp-popup-actions>

